import { Button } from '@mui/material';
import type { ICustomButtonProps } from '../../types/ITypes';

export const CustomButton = (props: ICustomButtonProps) => {
  return (
    <Button
      variant={props.variant}
      className={`p-5px mr-5px common-btn ${props.className ?? ''}`}
      disabled={props.disabled}
      onClick={() => props.handleAction(props.type)}
      startIcon={props.startIcon}
    >
      {props.label}
    </Button>
  );
};
